import { AppModeController } from "./scenes/AppModeController";
export const getSceneModule = () => {
    return new AppModeController();
};
